import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { PracticeDto } from '../api/generated';
import { OrganisationSelectionError } from '../utils/errors';
import { PatientSearchStatus, patientsSearchStatusAtom } from './patientSearch';
import { whoamiAtom } from './whoami';

const selectedOrganizationKeyAtom = atomWithStorage<string | null>('selectedOrganizationKey', null, undefined, {
  getOnInit: true,
});

const selectedOrganizationAtom = atom(
  async (get) => {
    const { data: whoami } = await get(whoamiAtom);
    const { practices } = whoami;
    if (!practices.length) {
      throw new OrganisationSelectionError(
        'Diesem Benutzer sind keine freigeschaltenen Praxen zugewiesen.',
        'Fehler beim Laden der Praxen des Benutzers',
      );
    }
    const storedSelectedOrganizationKey = get(selectedOrganizationKeyAtom);
    if (storedSelectedOrganizationKey) {
      const storedSelectedOrganization = practices.find((practice) => practice.id === storedSelectedOrganizationKey);
      if (storedSelectedOrganization) {
        return storedSelectedOrganization;
      }
    }
    return practices[0];
  },
  (get, set, arg: PracticeDto) => {
    set(selectedOrganizationKeyAtom, arg.id);
    set(patientsSearchStatusAtom, PatientSearchStatus.ALL);
  },
);

export { selectedOrganizationAtom };
